import { ArrowUp } from 'lucide-react'
import { useLocation } from 'react-router-dom'
import { useTranslation } from '@/i18n'
import { useAppStore } from '@/store'
import { AKEERA_AVATAR_SRC } from './constants'
import { getSuggestionsForRoute } from './suggestedQuestionsMap'

/**
 * Opening view, to Putra's design (2026-10-16 update): the Akeera avatar as
 * the hero, "How can I help?" as the heading, a line of explanation, then
 * the suggestions as rows with an arrow affordance.
 *
 * The heading and the explanation are the design's fixed copy. Only the ROWS
 * follow the route: the design shows the generic set, which is what a page
 * with no set of its own gets.
 *
 * The hero is the avatar, not a spark mark: the update replaced the mark with
 * the face. The launcher's copy of it is in the page header, a card-width
 * away, so the pair reads as "this card is hers" rather than as a duplicate.
 *
 * No "Other" row: the composer sits right under the rows for any question
 * they do not cover.
 */
const SuggestedQuestions = () => {
  const { t } = useTranslation('help_agent')
  const location = useLocation()
  const sendHelpMessage = useAppStore((s) => s.sendHelpMessage)

  const entry = getSuggestionsForRoute(location.pathname)

  return (
    <div className="flex flex-col gap-5 p-4">
      <img
        src={AKEERA_AVATAR_SRC}
        alt=""
        className="size-12 shrink-0 rounded-full object-cover"
      />
      <div className="flex flex-col gap-2">
        <h2 className="text-xl font-semibold leading-snug text-gray-900 dark:text-dark-text">
          {t('empty.title')}
        </h2>
        <p className="text-sm leading-relaxed text-muted-foreground">{t('empty.subtitle')}</p>
      </div>
      <div className="mt-4 flex flex-col gap-2.5">
        {entry.questionKeys.map((questionKey) => {
          const question = t(questionKey)
          return (
            <button
              key={questionKey}
              type="button"
              onClick={() => void sendHelpMessage(question, location.pathname)}
              className="group flex w-full items-center gap-3 rounded-lg border border-gray-200 bg-white px-4 py-3 text-start text-sm text-gray-900 transition-colors hover:bg-gray-50 dark:border-dark-border dark:bg-dark-card dark:text-dark-text dark:hover:bg-dark-accent"
            >
              <span className="min-w-0 flex-1">{question}</span>
              <ArrowUp
                className="size-4 shrink-0 text-muted-foreground transition-colors group-hover:text-foreground"
                aria-hidden="true"
              />
            </button>
          )
        })}
      </div>
    </div>
  )
}

export default SuggestedQuestions
